import * as actions from "./preference.actions";
import * as api from "./preference.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./preference.constants";
import * as hooks from "./preference.hooks";
import * as promises from "./preference.promises";
import reducer from "./preference.reducer";
import { saga } from "./preference.saga";
import * as selectors from "./preference.selectors";
import * as utils from "./preference.utils";
export * from "./preference.types";
export var REDUCER_KEY_PREFERENCE = REDUCER_KEY;
export var preferenceModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
